/**
 * The cache keys of one resource, built the same way everywhere so invalidation is predictable:
 *
 *   keys.root            ['users']                  everything about users
 *   keys.lists()         ['users','list']           every cached page of any filter
 *   keys.list(filters)   ['users','list', {...}]    one page of one filter
 *   keys.alls()          ['users','all']            every "whole list"
 *   keys.all(filters)    ['users','all', {...}]     the whole list of one filter
 *   keys.details()       ['users','detail']         every single user
 *   keys.detail(id)      ['users','detail', id]     one user
 *
 * Invalidating a shorter key also invalidates every longer key that starts with it.
 */
export function createQueryKeys<const TName extends string>(name: TName) {
  return {
    root: [name] as const,
    lists: () => [name, 'list'] as const,
    list: (filters: object = {}) => [name, 'list', filters] as const,
    alls: () => [name, 'all'] as const,
    all: (filters: object = {}) => [name, 'all', filters] as const,
    details: () => [name, 'detail'] as const,
    detail: (id: string) => [name, 'detail', id] as const,
  }
}

export type QueryKeys = ReturnType<typeof createQueryKeys>
